import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Apollo, Mutation } from 'apollo-angular';
import { DeleteAwardCriteriaDto } from 'src/app/service/award.service';

export type DeleteAwardCriteriaMutationVariables = {
    id: DeleteAwardCriteriaDto;
};

export type DeleteAwardCriteriaMutation = {
    deleteAwardCriteria: boolean;
};

export const DeleteAwardCriteriaDocument = gql`
  mutation DeleteAwardCriteria($id: DeleteAwardCriteriaDto!) {
    deleteAwardCriteria(id: $id)
  }
`;

@Injectable({
    providedIn: 'root',
})
export class DeleteAwardCriteriaGQL extends Mutation<
    DeleteAwardCriteriaMutation,
    DeleteAwardCriteriaMutationVariables
> {
    document = DeleteAwardCriteriaDocument;

    constructor(apollo: Apollo) {
        super(apollo);
    }
}
